import React, { useMemo } from "react";
import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import moment from "moment";

const useSecurePassOutreachColumns = () => {
  return useMemo(
    () => [
      {
        title: "Attempted At",
        key: "creationTime",
        dataIndex: "creationTime",
        render: text => (
          <span className="span-click">
            {text ? moment.utc(text).locale("en").local().format("M/D/YY, h:mm A") : ""}
          </span>
        ),
      },
      {
        title: "Comments",
        key: "comments",
        dataIndex: "comments",
        render: text => <span className="span-click">{text === "-" || !text ? "N/A" : text}</span>,
      },
      {
        title: "Was Successful",
        key: "isSuccess",
        dataIndex: "isSuccess",
        align: "center",
        render: text =>
          text ? (
            <CheckCircleFilled style={{ color: "#52c41a", fontSize: 18 }} />
          ) : (
            <CloseCircleFilled style={{ color: "red", fontSize: 18 }} />
          ),
      },
    ],
    [],
  );
};

export default useSecurePassOutreachColumns;
